export default __webpack_public_path__ + "static/media/11_ochrana-proti-loupani-min.c7d71f72.jpg";